import { render, staticRenderFns } from "./AdminCompanyApply.vue?vue&type=template&id=3cc6bdff&scoped=true&"
import script from "./AdminCompanyApply.vue?vue&type=script&lang=js&"
export * from "./AdminCompanyApply.vue?vue&type=script&lang=js&"
import style0 from "./AdminCompanyApply.vue?vue&type=style&index=0&id=3cc6bdff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc6bdff",
  null
  
)

export default component.exports